export default {
  subLabel: {
    id: 'policy_card_sub_label',
    defaultMessage: 'For {productTitle}',
  },
  startDate: {
    id: 'policy_card_start_date',
    defaultMessage: 'Activates on {startDate}',
  },
  expiredOn: {
    id: 'policy_card_expired_on',
    defaultMessage: 'Expired on {endDate}',
  },
  cancelledOn: {
    id: 'policy_card_cancelled_on',
    defaultMessage: 'Canceled on {endDate}',
  },
}
